import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';

export interface Entity {
    name?: string;
}

interface ServiceWithGetById<T> {
    getById(id: number): Promise<T | null>;
}

export const entityDataResolver: ResolveFn<Entity | null> = async (route: ActivatedRouteSnapshot) => {
    const entityId = Number(route.paramMap.get('id'));

    const serviceClass = route.data['service'] as (new (...args: never[]) => ServiceWithGetById<Entity>) | undefined;

    if (!serviceClass || !entityId) {
        return null;
    }

    try {
        const service = inject(serviceClass);
        return (await service.getById(entityId)) ?? null;
    } catch (error) {
        console.error('Error Loading Entity', error);
        return null;
    }
};
